import React from "react";
import { Link } from "react-router-dom";
import CatalogImage from "../common/CatalogImage";
import StatusBadge from "../common/StatusBadge";
import { formatCurrency, formatDate, packageNetPrice } from "../../lib/catalog";
import { packageSeatSummary } from "../../lib/packageSeats";
import { displayValue, formatDuration } from "./packageDetailModel";

export default function PackageCard({ pkg }) {
  const seats = packageSeatSummary(pkg);
  const soldOut = seats.soldOut;
  const status = soldOut ? "Sold Out" : (pkg.status || "Unknown");
  const detailTo = `/packages/${pkg.slug || pkg.id}`;

  return (
    <article className="card h-100 border-0 shadow-sm catalog-card package-card">
      <CatalogImage
        folder="umrah_package"
        fileName={pkg.image}
        alt={pkg.name}
        height="auto"
        className="package-card__image"
      />
      <div className="card-body d-flex flex-column">
        <div className="package-card__top">
          <div className="text-uppercase text-secondary small fw-semibold package-card__code">
            {pkg.code || "No code"}
          </div>
          <StatusBadge className="flex-shrink-0" value={status} />
        </div>

        <h5 className="card-title package-card__name" title={pkg.name}>
          {pkg.name}
        </h5>

        <div className="package-card__meta">
          <div className="package-card__row">
            <span className="package-card__label">Departure</span>
            <span className="package-card__value">{formatDate(pkg.departureDate)}</span>
          </div>
          <div className="package-card__row">
            <span className="package-card__label">Duration</span>
            <span className="package-card__value">{displayValue(formatDuration(pkg), "Not set")}</span>
          </div>
          <div className="package-card__row">
            <span className="package-card__label">Available seats</span>
            <span className="package-card__value">{seats.total ? `${seats.available} / ${seats.total}` : displayValue(pkg.seats, "Not set")}</span>
          </div>
        </div>

        <div className="package-card__footer mt-auto">
          <div className="package-card__prices">
            <div className="package-card__label">Net Price</div>
            <div className="package-card__net">{formatCurrency(packageNetPrice(pkg))}</div>
          </div>
          {soldOut ? (
            <button type="button" className="btn btn-secondary btn-sm package-card__book" disabled>
              Sold Out
            </button>
          ) : (
            <Link to={detailTo} className="btn btn-primary btn-sm package-card__book">
              Book
            </Link>
          )}
        </div>
      </div>
    </article>
  );
}
